'use client';

import { PropsWithChildren } from 'react';
import { useRedirect } from '@/locale/hooks';

export default function LocaleRedirect() {
  useRedirect();
  return null;
}

// interface ILocaleLoadProps extends PropsWithChildren {
//   locale: string;
//   messages?: Record<string, string>;
// }

export function I18nLoad({ children }: PropsWithChildren) {
  // useLocale();
  return <>{children}</>;
}
